<div class="flex" app-layout>
  <app-card class="w-full h-min">
    <div app-card-content class="h-72">
      <app-jumbotron [showIcon]="false">
        <div class="flex w-auto flex-col items-center text-center">
          <svg-icon src="assets/icons/icon-alert-fill-fine.svg" class="w-20 text-gray-400"></svg-icon>
          @for (item of forbidden() | keyvalue; track $index) {
            <div class="text-xl font-semibold text-gray-400">
              {{ label(item.key) | translate: item.value }}
            </div>
          }
        </div>
      </app-jumbotron>
    </div>
  </app-card>
</div>
